import axios from 'axios'
import { useRouter } from 'next/dist/client/router'
import React, { useEffect, useState, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { productsReceived, extractCategories, productsSetFilters, getFilteredProducts, loadGeoProducts, getProductsCategories, getProductsFilters } from '../../store/slices/entities/products';
import { wrapper } from '../../store/configStore';
import { SERVER_IP } from '../../store/middleware/api';
import { NextSeo } from 'next-seo';
import { helper } from '../../utilities/helper';
import PicCont from '../../components/PicCont';
import lineToBr from '../../components/lineToBr';
import oldContent from '../../utilities/oldContent';
import SubCatCont from '../../components/SubCatCont';
import catPictures from '../../utilities/catPictures'
import categoriesSEO from '../../utilities/categoriesSEO'
import LinkWrap from '../../components/LinkWrap';
import Button from '../../components/Button';
import audio from '../../public/Pictures/audio-equipment.png'
import dynamic from 'next/dynamic'
import cdj from '../../public/Pictures/cdj.png'
import lighting from '../../public/Pictures/stage-lighting.png'
import visuals from '../../public/Pictures/visuals.png'
import coldspark from '../../public/Pictures/cold-spark-machine.png'
import projector from '../../public/Pictures/projector.png'
import { AiOutlinePhone } from "@react-icons/all-files/ai/AiOutlinePhone";
import { getUserUTM } from '../../store/slices/user';
import * as gtag from '../../lib/gtag'
import { SHOW_POPUP } from '../../store/slices/ui';
import { Spinner } from '../../components/Components';
import categoriesSubtitles from '../../utilities/categoriesSubtitles';
import CatBar from '../../components/CatBar';
import { compactCatalogProducts } from '../../utilities/catalogPublicPayload';


const StageBuilder = dynamic(() => import('../../components/StageBuilder'), {suspense: true})
export const getStaticProps = wrapper.getStaticProps(
  async ({ store, preview, params }) => {
    const { lastFetched } = store.getState().entities.products
    if (!lastFetched || moment().diff(moment(lastFetched), 'minutes') > 10) {
      const res = await axios.request(`${SERVER_IP}/inventory/product?msr=true&cat=${params.category}`)
      store.dispatch({ type: productsReceived.type, payload: compactCatalogProducts(res.data) })
      store.dispatch({ type: productsSetFilters.type, payload: {static: true} })
    }
    return { props: { cat: params.category } }
  }
);

export async function getStaticPaths() {
  const res = await axios.request(`${SERVER_IP}/inventory/product`)
  let categories = extractCategories(res.data)
  const paths = Object.keys(categories).filter(c => !['Bundle', 'Sound', 'DJ Equipment', 'Lighting', 'Staging', 'Special Effects', 'Visuals'].includes(c)).map(category => ({ params: { category: helper.tagLower(category).replace(/_/g, '-') } }))
  return {
    paths,
    fallback: false
  }
}

const SubCategory = ({ cat }) => {
  let { push, query, asPath } = useRouter()
  let utm = useSelector(getUserUTM)
  let dispatch = useDispatch()
  let categor = useSelector(getProductsCategories)
  let products = useSelector(getFilteredProducts)
  let oCat = cat

  if (!Array.isArray(categor[helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)])) return <div></div>

  return <>
    <NextSeo
      // noindex={cat === 'staging'}
      title={categoriesSEO[oCat]?.title ? categoriesSEO[oCat]?.title : `${helper.tagUpper(cat)} Rental - Miami Audio Visual`}
      description={categoriesSEO[oCat]?.description ? categoriesSEO[oCat]?.description : `${helper.tagUpper(cat)} Rental in Miami and South Florida. ${categor[helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)]?.join(', ')} products and much more. `}
      canonical={`https://miamisoundrental.com/equipment/${oCat}`}
      twitter={{
        handle: '@miamisoundrent1',
        site: '@miamisoundrent1',
        cardType: 'summary_large_image',
      }}
      openGraph={{
        type: 'website',
        url: `https://miamisoundrental.com/equipment/${oCat}`,
        title: categoriesSEO[oCat]?.title ? categoriesSEO[oCat]?.title : `${helper.tagUpper(cat)} Rental - Miami Audio Visual`,
        description: categoriesSEO[oCat]?.description ? categoriesSEO[oCat]?.description : `${helper.tagUpper(cat)} Rental in Miami and South Florida. ${Object.keys(categor).find(key => categor[key].map(sc => helper.tagLower(sc)).includes(cat))} products and much more. `,
        images: [
          {
            url: `https://dnw-server.s3.us-east-2.amazonaws.com/${categoriesSEO[oCat]?.og ? categoriesSEO[oCat]?.og : `msr_og.jpg`}`,
            width: 800,
            height: 600,
            alt: 'Miami Sound Rental',
          },
        ],
        site_name: 'Miami Sound Rental',
      }}
    />
    <div className='productPage' >
           <CatBar />
      <h1 > {categoriesSEO[oCat]?.h1 ? categoriesSEO[oCat]?.h1 : helper.tagUpper(cat) + ' Rental Miami'} </h1>
      {categoriesSEO[oCat]?.sub && <p className='subPar' >{lineToBr(categoriesSEO[oCat]?.sub, oCat)}</p>}


      <div className="headRow">
        {[...categor[helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)]]?.filter(c => !['Karaoke', 'Projector'].includes(c)).sort((a, b) => ['Microphones', 'Cables', 'Booth', 'Bundle', 'Recorders', 'Subwoofer'].includes(b) ? -1 : 1).map((subCat, i) => {
          let filt_products = products.filter(p => p.categories.some(_cat => _cat === `${helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)}/${subCat}`))
          let product = filt_products[1] || filt_products[0]
          return <div key={i} className='catHead'>
            <PicCont priority={i === 0} alt={subCat} src={catPictures[helper.tagLower(['Mixers', 'Bundle'].includes(subCat) ? cat + ' ' + subCat : subCat)]} picture={product?.picture} height={200} width={200} />
            <a className='button btn-2' href={`/${helper.makeUrl(oCat)}/${helper.makeUrl(subCat)}`} >{subCat}</a>
          </div>
        })}
      </div>
      <a className="assCall ONLYPHONE" href="tel:+13059744411" onClick={() => gtag.event({ action:  'booking_assistance_call', label: 'leads', value: 15, category: 'orders' })}>
                     <AiOutlinePhone />305 974 4411
       </a>
      <div className='mainBody' >
        <div className='mainBody-scroll' >
          {[...categor[helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)]]?.filter(c => !['Karaoke', 'Projector'].includes(c)).sort((a, b) => ['Microphones', 'Cables', 'Booth', 'Bundle', 'Recorders', 'Subwoofer'].includes(b) ? -1 : 1).map((subCat, i) => {
            let filt_products = products.filter(p => p.categories.some(_cat => _cat === `${helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)}/${subCat}`))
            let product = filt_products[1] || filt_products[0]

            return <section key={i} className="subCategory" id={helper.tagLower(subCat)}>
              <div className="topRow">
                <div className="leftCol">
                  <LinkWrap  href={`/${helper.makeUrl(oCat)}/${helper.makeUrl(subCat)}`} >
                  <h2>{categoriesSubtitles[helper.tagLower(['Mixers', 'Bundle', 'Microphones'].includes(subCat) ? cat + ' ' + subCat : subCat)] || subCat}</h2>
                  </LinkWrap>

                  {oldContent[helper.tagLower(['Mixers', 'Bundle', 'Microphones'].includes(subCat) ? cat + ' ' + subCat : subCat)] && oldContent[helper.tagLower(['Mixers', 'Bundle', 'Microphones'].includes(subCat) ? cat + ' ' + subCat : subCat)]}
                  {['Stage Risers','Stage Bundles'].includes(subCat) && <Button onClick={() => dispatch(SHOW_POPUP({size: 'xxl', key: 'stageBuilder', body: <Suspense fallback={<Spinner size='tiny' />}><StageBuilder /></Suspense>}) )}className='btn-5 highLight animated'>Build Stage</Button>}
                </div>

                <PicCont priority={i === 0} alt={subCat} src={catPictures[helper.tagLower(['Mixers', 'Bundle'].includes(subCat) ? cat + ' ' + subCat : subCat)]} picture={product?.picture} height={600} width={600} />

             </div>
              <SubCatCont key={subCat} subCat={subCat} products={products.filter(p => p.categories.some(c => c === `${helper.tagUpper(cat) === 'Dj Equipment' ? 'DJ Equipment' : helper.tagUpper(cat)}/${subCat}`))} />
            </section>
          })}
        </div>
      </div>
    </div>
  </>
}

export default SubCategory
